/* global CVP */

// ### Util
//
// Collection of simple utility functions.

'use strict';

var _ = require('./vendor/underscore');
var Dom = require('./dom');


function assert(value, msg) {
	if (!value) {
		throw new Error(msg || (value + ' is not truthy'));
	}
}

function assertEqual(val1, val2, msg) {
	if (val1 !== val2) {
		throw new Error(msg || (val1 + ' does not equal ' + val2));
	}
}


function toNum(str) {
	return +(str);
}

function toInt(num) {
	return parseInt(num, 10);
}

var toUpper = _.bind(Function.prototype.call, String.prototype.toUpperCase);


var nativeTrim = String.prototype.trim;
var allSpaceAtEndsRegex = /^\s+|\s+$/g;
function shimTrim() {
	/* jshint validthis:true */
	return this.replace(allSpaceAtEndsRegex, '');
}
var libTrim = _.isFunction(nativeTrim) ? nativeTrim : shimTrim;

function trim(text) {
	/* jshint eqnull:true */
	return text == null ? '' : libTrim.call(text);
}


var urlRegex = /^((([^:\/?#]+):)?(?:\/\/(([^\/?#]*)(?::(\d+))?))?)(([^?#]*\/)([^\/?#]*)?)(\?([^#]*))?(#(.*))?$/;
var allUrlEncodedSpaces = /%20/g;

function parseUrl(url) {
	// "normalize" URL: turn relative paths into full URLs relative to page URL
	// (I reserve "canonical" for when full URL + explicit ports are needed.)
	var a = window.document.createElement('a');
	a.href = url;
	var href = a.href;
	a = null;

	var match = urlRegex.exec(href);

	if (match) {
		return {
			href     : match[0]  || '',
			origin   : match[1]  || '',
			protocol : match[2]  || '',
			scheme   : match[3]  || '',
			host     : match[4]  || '',
			hostname : match[5]  || '',
			port     : match[6]  || '',
			pathname : match[7]  || '',
			dir      : match[8]  || '',
			file     : match[9]  || '',
			search   : match[10] || '',
			query    : match[11] || '',
			hash     : match[12] || '',
			anchor   : match[13] || ''
		};
	}
}

var allQueryParamsRegex = /([^?&=]+)(?:=([^&=]+))?/g;
var decode = window.decodeURIComponent;
function parseQueryString(queryString) {
	var queryObject = {};
	queryString.replace(allQueryParamsRegex, function ($0, $1, $2/*, offset, string*/) {
		queryObject[$1] = $2 ? decode($2) : '';
		return $0;
	});
	return queryObject;
}

var encode = window.encodeURIComponent;
function toQueryKeyValueString(value, key/*, list*/) {
	return (encode(key) + (value !== '' ? '=' + encode(_.isObject(value) ? CVP.JSON.stringify(value) : value) : '') );
}

function encodeParams(obj) {
	var queryArray = _.map(obj, toQueryKeyValueString);

	return queryArray.join('&').replace(allUrlEncodedSpaces, '+');
}

function toQueryString(hash) {
	var params = encodeParams(hash);

	var queryString = params ? '?' + params : '';

	return queryString;
}

function augmentQueryString(url, data) {
	var urlParts = parseUrl(url);
	var queryParts = parseQueryString(urlParts.query);

	queryParts = _.extend({}, queryParts, data);

	var queryString = toQueryString(queryParts);

	return urlParts.origin + urlParts.pathname + queryString + urlParts.hash;
}


var loadScript = (function loadScript() {
	var counter = 0;
	var tag = 'script';
	return function (url, callbackOrConfig) {
		if (typeof url !== 'string') {
			throw new Error('invalid param!');
		}

		var options = {};
		switch (typeof callbackOrConfig) {
		case 'object':
			options = callbackOrConfig;
			break;
		case 'function':
			options.success = callbackOrConfig;
			break;
		}

		var el = Dom.create(tag),
			s1 = Dom.tags(tag)[0],
			readyRE = /^(complete|loaded)$/,
			done = false,
			timedout = function () {
				el.onerror();
			},
			timer = _.isFinite(options.timeout) ? window.setTimeout(timedout, options.timeout) : null,
			noop = function () {},
			success = _.isFunction(options.success) ? options.success : noop,
			failure = _.isFunction(options.failure) ? options.failure : noop,
			complete = _.isFunction(options.complete) ? options.complete : noop,
			cleanup = function () {
				window.setTimeout(complete, 0);
				window.clearTimeout(timer);
				el.onload = el.onreadystatechange = el.onerror = null;
				if (options.cleanup) {
					if (el.parentElement) {
						el.parentElement.removeChild(el);
					}
				}
				el = null;
			};

		el.onload = el.onreadystatechange = function () {
			if (!done && (!('readyState' in el) || readyRE.test(el.readyState))) {
				done = true;
				window.setTimeout(success, 0);
				window.setTimeout(cleanup, 0);
			}
		};
		el.onerror = function () {
			if (!done) {
				done = true;
				window.setTimeout(failure, 0);
				window.setTimeout(cleanup, 0);
			}
		};
		el.id = options.id || ('cvpauth_load_' + (counter += 1));
		el.src = url;
		s1.parentNode.insertBefore(el, s1);
	};
}());


var allRegexMetasRegex = /[\-\[\]{}()*+?.,\\\^\$|#\s]/g;
function escapeRegExp(text) {
	return text.replace(allRegexMetasRegex, '\\$&');
}


function padInt(num, places) {
	if (num < 0 || isNaN(num)) {
		return String(num);
	}
	places = places || 2;
	num = Math.floor(num).toString();
	var padding = places - num.length;
	if (padding <= 0) {
		return num;
	}
	var ohs = (new Array(padding + 1)).join('0');
	return (ohs + num);
}


var simpleUrlRegex = /^([^?#]+)(\?[^#]+)?(#.+)?/;
// ^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?
function createRedirectUrl(url) {

	// If the user explicitly passes null or empty string,
	// assume that they intentionally desire to stay at the same url.
	if (url === null || url === '') {
		return null;
	}

	// If the param is not provided,
	// use the current location instead.
	if (url === undefined) {
		url = window.location.href;
	}

	var regexResult = simpleUrlRegex.exec(url);

	// If regex was unsuccessful,
	// return the url that was provided.
	if (!regexResult) {
		return url;
	}

	var location = regexResult[1] || '';
	var query = regexResult[2] || '';
	var fragment = regexResult[3] || '';

	var queryObject = parseQueryString(query);

	// If the URL has a hash, add a cache-busting query string value.
	// Otherwise, the page may not reload when Adobe attempts to later.
	if (fragment) {
		var date = new Date();
		var hr = padInt(date.getHours());
		var min = padInt(date.getMinutes());
		var sec = padInt(date.getSeconds());
		queryObject._ = hr + min + sec;
	}

	var queryString = toQueryString(queryObject);

	url = location + queryString + fragment;

	return url;
}


exports.assert = assert;
exports.assertEqual = assertEqual;
exports.toNum = toNum;
exports.toInt = toInt;
exports.toUpper = toUpper;
exports.trim = trim;
exports.parseUrl = parseUrl;
exports.parseQueryString = parseQueryString;
exports.augmentQueryString = augmentQueryString;
exports.loadScript = loadScript;
exports.escapeRegExp = escapeRegExp;
exports.padInt = padInt;
exports.createRedirectUrl = createRedirectUrl;
